import React, { useState } from "react";
import "./Portfolio.css";
import cut1 from "../../assets/download.svg";
import flag from "../../assets/flag.svg";
import house from "../../assets/house.svg";
import ap from "../../assets/ap.svg";
import skull from "../../assets/skull.svg";
import resume from "../../assets/resume.png"; 

const Portfolio = () => {
  const [selectedDiv, setSelectedDiv] = useState(0);
  const [fullstack,setfullstack]=useState(true);
  const [uiux,setuiux]=useState(false);
  const [coding,setcoding]=useState(false);
  const [trading,settrading]=useState(false);
  const [count,setcount]=useState(6);
  const [styles,setstyles]=useState(1);

  const handleSelectDiv = (sum) => {
    if (sum > 0) {
      setSelectedDiv((selectedDiv + sum) % count);
    } else {
      let newSelectedDiv = selectedDiv - Math.abs(sum) % count;
      if (newSelectedDiv < 0) {
        newSelectedDiv = count + newSelectedDiv;
      }
      setSelectedDiv(newSelectedDiv);
    }
  };

  const booleans = (bool) =>{
    if(bool===1){
      setfullstack(true);
      settrading(false);
      setuiux(false);
      setcoding(false);
      setcount(5);
      setSelectedDiv(0);
      setstyles(1);
    }
    if(bool===2){
      setfullstack(false);
      settrading(false);
      setuiux(true);
      setcoding(false);
      setcount(4);
      setSelectedDiv(0);
      setstyles(2);
    }
    if(bool===3){
      setfullstack(false);
      settrading(false);
      setuiux(false);
      setcoding(true);
      setSelectedDiv(0);
      setcount(4);
      setstyles(3);
    }
    // if(bool==4){
    //   setfullstack(false);
    //   settrading(true);
    //   setuiux(false);
    //   setcoding(false);
    //   setSelectedDiv(0);
    //   setcount(2);
    //   setstyles(4);
    // }

  };

  const progressBarStyle = {
    backgroundSize: `${((selectedDiv + 1) * 100) / count}% 100%`,
  };

  
  // const divstyle =  {
  //   backgroundColor:"#e4a654",
  //   color:"#e4e4e4",
  // };

  const getButtonStyle = (buttonId) => {
    if (buttonId === styles) {
      return { backgroundColor:"#e4a654", color:"#e4e4e4"};
    }
    return { Color: '#e4a654' };
  };
  

  return (
    <div className="cover1">
      <div className="portfolio-section">
        <div className="portfolio">
          <div className="container1">
            <a onClick={() => handleSelectDiv(-1)} className="left-arrow1">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
            <a onClick={() => handleSelectDiv(1)} className="right-arrow1">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
         
            <h5 className="h51">Featured Projects</h5>
            <h2 className="lh21">
              <strong>Projects fully crafted</strong> in house
              <span className="im">
                <img alt="cut1" className="cut1" src={cut1} />
              </span>
              <img
                decoding="async"
                src={house}
                alt="Checked house illustration"
                className="house-icon"
              />
            </h2>
            <div className="services1">

            <img decoding="async" src={ap} alt="Amazing projects text bubble" className="tiny1"/>
            <img
              decoding="async"
              src={skull}
              alt="Skull Icon"
              className="skull1"
              data-rellax-speed="1"
            ></img>
              <img
                decoding="async"
                data-aos="fade-up"
                data-aos-offset="50"
                src={flag}
                alt="Hreat flagpole illustration"
                className="flag-icon1"
                data-rellax-speed="1"
              ></img>

              <div className="out-content1">

              <div id="portfolio" className="multi-button">
  <button className="fullstack-ga" style={getButtonStyle(1)} onClick={() => booleans(1)}>WEBSITES</button>
  <button className="figma-ga" style={getButtonStyle(2)} onClick={() => booleans(2)}>UI/UX</button>
  <button className="coding-ga" style={getButtonStyle(3)} onClick={() => booleans(3)}>CP</button>
  {/* <button className="tradevest-ga" style={getButtonStyle(4)} onClick={() => booleans(4)}>TRADEVEST</button> */}
</div>


{selectedDiv === 0 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={w0}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/AAr.png?updatedAt=1708015215403"
                          alt="Aarryamaan"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Aarryamaan</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                           A Business Portfolio
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://aarryamaan.com"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

{selectedDiv === 1 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={w0}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/w0.png?updatedAt=1708011056700"
                          alt="Website"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Placement Management System</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                           Paving the path to success
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://drive.google.com/file/d/1GQU56bq0N1mGuk_ysC9h53GviSYJGxoi/view?usp=sharing"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/Placement-Webiste"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}


                {selectedDiv === 2 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={w1}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/w1.png?updatedAt=1708011058123"
                          alt="Website"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Bullsight</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                            Unleash Your Trading Edge
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://bullsight.app"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/BullSight"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

                {selectedDiv === 3 && fullstack &&(
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={w2}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/w2.png?updatedAt=1708011059453"
                          alt="Website"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Foodchef</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                            Healthy eating made simple
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://foodchef-pravinkanth.netlify.app/"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/FOODCHEF"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

{selectedDiv === 4 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={erp}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/erp.png?updatedAt=1708011051439"
                          alt="ERP"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">ERP</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                            Freelance Project<br></br> (Non-disclosure)
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://drive.google.com/drive/folders/19z6CoT-C36nC5DLsZh3gzR7mksh_Ge6z?usp=sharing"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                             <a
                              target="_blank"
                              className="links2"
                              href="https://github.com/PravinKanth/LITVIK"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

{selectedDiv === 5 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={MAI}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/MAI.png?updatedAt=1708011053244"
                          alt="InnoVest"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">InnoVest</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          A Crowdfunding Web App
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://pravin-kanth.netlify.app/"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                            <a
                              target="_blank"
                              className="links2"
                              href="https://github.com/PravinKanth/Mindfulai-Updation"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
{/* 
{selectedDiv === 6 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={port}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/Screenshot%202024-02-15%20210608.png?updatedAt=1708011344114"
                          alt="Portfolio"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Portfolio</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          My Portfolio, A Reflection of Passion
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://pravinkanth.com/"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              className="links2"
                              href="https://github.com/PravinKanth/Portfolio"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

{/* 
{selectedDiv === 7 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={expense}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/expense.png?updatedAt=1708011052646"
                          alt="Expense tracker"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Expense Tracker</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                            Track & Manage your expenses at ease
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://expensetracker-pravinkanth.netlify.app/"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              className="links2"
                              href="https://github.com/PravinKanth/Expense-Tracker"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

{/* {selectedDiv === 8 && fullstack && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={w3}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/w3.png?updatedAt=1708011059501"
                          alt="Website"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">calculator</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                            Your Reliable Calculator.
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://calculator-pravinkanth.netlify.app/"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            <a
                              target="_blank"
                              className="links2"
                              href="https://github.com/PravinKanth/Calculator"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

                {/* ui/ux */}

                {selectedDiv === 0 && uiux && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={appointment}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/Appointment%20dashboard.jpg?updatedAt=1708011047318"
                          alt="Doctor Booking - UI/UX"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">doctor booking</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Effortless Doctor Booking
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://www.figma.com/file/bjZdPwmcqm7LQEY17N0j1u/Doctor-booking?type=design&node-id=0%3A1&t=dO0WacxNnYYKDPj5-1"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/BullSight"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a> */}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

{selectedDiv === 1 && uiux && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={appointment}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/Aarryamaan.png?updatedAt=1708012675798"
                          alt="Aarryamaan"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Aarryamaan</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          A Business Portfolio
                          </h5>
                        </div>
                      </div>

                    </div>
                  </div>
                )}


{/* {selectedDiv === 3 && uiux && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={appointment}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/Group%203663.png?updatedAt=1708015068017"
                          alt="Covers"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Banners</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Linkedin & Twitter
                          </h5>
                        </div>
                      </div>

                    </div>
                  </div>
                )} */}




{selectedDiv === 2 && uiux && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={cit}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/cit.jpg?updatedAt=1708011049738"
                          alt="EduTech - UI/UX"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Edutech</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Simplified User Experiences
                          </h5>
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://www.figma.com/file/G4MsQ6XPnMgfjmBUj4QC0k/Cryptera-2023?type=design&node-id=0%3A1&t=lBpnQIe0lkx36CmN-1"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/BullSight"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a> */}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

{selectedDiv === 3 && uiux && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          src={resume}
                          // src="https://ik.imagekit.io/jtnilec50/Portfolio/resumesvg.svg?updatedAt=1708011061009"
                          alt="Resume"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">My RESUME</h3>
                          {/* <h2 className="x">x</h2> */}
                          {/* <h5 className="port-para">
                          Simplified User Experiences
                          </h5> */}
                          <div className="links">
                            <a
                              target="_blank"
                              href="https://www.figma.com/file/r45jqsOnep1CIoVCtPv8ei/RESUME?type=design&node-id=79%3A5&mode=design&t=1KCQXXzkv9uT672f-1"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a>
                            
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/BullSight"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a> */}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

                {/* CODING */}

                {selectedDiv === 0 && coding && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={atm}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/atm.png?updatedAt=1708011047245"
                          alt="ATM - Console"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">ATM Console</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Seamless Console Banking
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/ATM---console-application-"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                            
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/ATM---console-application-"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

{selectedDiv === 1 && coding && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={spliwise}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/splitwise.png?updatedAt=1708011056277"
                          alt="Splitwise - Console"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">Splitwise Console</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Manage Group Budgets
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/ATM---console-application-"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                            
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/Splitwise---console-application-"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}


{selectedDiv === 2 && coding && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={bookmyshow}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/bookmyshow.png?updatedAt=1708011046936"
                          alt="Bookmyshow - Console"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">bookmyshow Console</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Command Your Entertainment Choices
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/ATM---console-application-"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                            
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/Book-my-show---console-application"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

{selectedDiv === 3 && coding && (
                  <div className="content1">
                    <div className="image-container">
                      <div className="wrap">
                        <img
                          className="image"
                          // src={railwaybooking}
                          src="https://ik.imagekit.io/jtnilec50/Portfolio/railwaybooking.png?updatedAt=1708011053429"
                          alt="RailwayBooking - Console"
                        ></img>
                        <div className="image-div">
                          <h3 className="port">railway Booking Console</h3>
                          <h2 className="x">x</h2>
                          <h5 className="port-para">
                          Console for Railway Travel
                          </h5>
                          <div className="links">
                            {/* <a
                              target="_blank"
                              href="https://github.com/PravinKanth/ATM---console-application-"
                            >
                              <ion-icon
                                className="link1"
                                name="link-outline"
                              ></ion-icon>
                            </a> */}
                            
                            <a
                              target="_blank"
                              href="https://github.com/PravinKanth/Railway-Booking---console-application-"
                            >
                              <ion-icon
                                className="link2"
                                name="logo-github"
                              ></ion-icon>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}

                {/* Finance */}

                    <div className="bar-padding">
                        <div
                          className="step-progress-bar"
                          role="progressbar"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          aria-valuenow="85.71428571428571"
                          style={progressBarStyle}
                        ></div>
                      </div>
                      <div className="step-progress-num">0{selectedDiv+1} - 0{count}</div>
              </div>
            </div>

          </div>

          <a href="#career" className="r90 left hide-el bl has-rotate hide-m" data-cursor="false" data-cursor-type="link">
    <span className="left">&larr;</span>
    <span className="text"> &nbsp;CAREER</span>
</a>



        </div>
      </div>
    </div>
  );
};

export default Portfolio;
